export default {"src":"/_next/static/media/projectSelected.bd313397.svg","height":21,"width":20,"blurWidth":0,"blurHeight":0};